// extracted by mini-css-extract-plugin
export default {"calender":"Calendar_calender__Tgcjc","stats":"Calendar_stats__z2uUW"};